import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import SubmitFull from "@/pages/SubmitFull";
import SubmitPhotos from "@/pages/SubmitPhotos";
import SubmitShort from "@/pages/SubmitShort";
import ThankYou from "@/pages/ThankYou";
import DraftResume from "@/pages/DraftResume";
import DemoAccess from "@/pages/DemoAccess";
import Login from "@/pages/Login";
import Welcome from "@/pages/Welcome";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import MyAccount from "@/pages/MyAccount";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminProjectDetail from "@/pages/AdminProjectDetail";
import AdminProjectEdit from "@/pages/AdminProjectEdit";
import AdminPdfPreview from "@/pages/AdminPdfPreview";
import AdminCaseStudyEdit from "@/pages/AdminCaseStudyEdit";
import AdminProjectOutputs from "@/pages/AdminProjectOutputs";
import AdminSettings from "@/pages/AdminSettings";
import AdminUsers from "@/pages/AdminUsers";
import AdminKnowledge from "@/pages/AdminKnowledge";
import SetupWizard from "@/pages/SetupWizard";
import CvList from "@/pages/CvList";
import CvBuilder from "@/pages/CvBuilder";
import RequireAuth from "@/components/RequireAuth";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
        <Routes>
          {/* Public auth pages */}
          <Route path="/login" element={<Login />} />
          <Route path="/demo/:token" element={<DemoAccess />} />
          <Route path="/setup" element={<SetupWizard />} />
          <Route path="/cvs" element={<RequireAuth><CvList /></RequireAuth>} />
          <Route path="/cvs/new" element={<RequireAuth><CvBuilder /></RequireAuth>} />
          <Route path="/cvs/:id" element={<RequireAuth><CvBuilder /></RequireAuth>} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/welcome" element={<RequireAuth><Welcome /></RequireAuth>} />

          {/* Legacy redirects */}
          <Route path="/gate" element={<Navigate to="/login" replace />} />
          <Route path="/admin/login" element={<Navigate to="/login" replace />} />

          {/* All app routes require a logged-in user */}
          <Route path="/" element={<RequireAuth><Home /></RequireAuth>} />
          <Route path="/submit/:draftToken" element={<RequireAuth><SubmitFull /></RequireAuth>} />
          <Route path="/submit-photos/:draftToken" element={<RequireAuth><SubmitPhotos /></RequireAuth>} />
          <Route path="/submit-award/:draftToken" element={<RequireAuth><SubmitShort flowKey="award" /></RequireAuth>} />
          <Route path="/submit-certification/:draftToken" element={<RequireAuth><SubmitShort flowKey="certification" /></RequireAuth>} />
          <Route path="/submit-event/:draftToken" element={<RequireAuth><SubmitShort flowKey="event" /></RequireAuth>} />
          <Route path="/submit-media/:draftToken" element={<RequireAuth><SubmitShort flowKey="media" /></RequireAuth>} />
          <Route path="/draft/:draftToken" element={<RequireAuth><DraftResume /></RequireAuth>} />
          <Route path="/thank-you" element={<RequireAuth><ThankYou /></RequireAuth>} />
          <Route path="/account" element={<RequireAuth><MyAccount /></RequireAuth>} />

          <Route path="/admin" element={<RequireAuth><AdminDashboard /></RequireAuth>} />
          <Route path="/admin/projects/:id" element={<RequireAuth><AdminProjectDetail /></RequireAuth>} />
          <Route path="/admin/projects/:id/edit" element={<RequireAuth><AdminProjectEdit /></RequireAuth>} />
          <Route path="/admin/projects/:id/case-study" element={<RequireAuth><AdminCaseStudyEdit /></RequireAuth>} />
          <Route path="/admin/projects/:id/outputs" element={<RequireAuth><AdminProjectOutputs /></RequireAuth>} />
          <Route path="/admin/projects/:id/preview" element={<RequireAuth><AdminPdfPreview /></RequireAuth>} />

          {/* Admin-only */}
          <Route path="/admin/settings" element={<RequireAuth adminOnly><AdminSettings /></RequireAuth>} />
          <Route path="/admin/users" element={<RequireAuth adminOnly><AdminUsers /></RequireAuth>} />
          <Route path="/admin/knowledge" element={<RequireAuth adminOnly><AdminKnowledge /></RequireAuth>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
